import { Component, Inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { IPerson } from '@lib-typing/person.interface';
import { Order } from '@libs-classes/order.class';
import { CommonDropdownComponent } from '@lib-ui/common-dropdawn/common-dropdown.component';
import { FormControl } from '@angular/forms';
import { PersonSelectorService } from '@lib-services/person-selector.service';
import { Role } from '@libs-enums/role.enum';
import { PersonStatusEnum } from '@libs-enums/status.enum';
import { MatButton } from '@angular/material/button';
import { MatError } from '@angular/material/form-field';
import { OrdersService } from '@lib-services/orders.service';
import { IOrderDataUpdate } from '@lib-typing/order.interface';
import { MessageService } from '@lib-services/message.service';
import { LoaderComponent } from '@lib-ui/loader/loader.component';
import { PersonSelectorComponent } from '@lib-ui/person-selector/person-selector.component';
import { Params } from '@angular/router';

@Component({
    selector: 'app-replace-tasks',
    standalone: true,
    imports: [
        CommonDropdownComponent,
        MatDialogContent,
        MatButton,
        MatError,
        LoaderComponent,
        PersonSelectorComponent,
    ],
    templateUrl: './replace-tasks.component.html',
    styleUrl: './replace-tasks.component.scss'
})
export class ReplaceTasksComponent {
    workerToReplace = new FormControl();
    loading = signal<boolean>(false);
    personAdditionalParams: Params = {};
    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: {
            worker: IPerson,
            workerTasks: Order[],
            currentDate: string
        },
        protected personSelectorService: PersonSelectorService,
        private dialogRef: MatDialogRef<ReplaceTasksComponent>,
        private ordersService: OrdersService,
        private messageService: MessageService
    ) {
        this.personAdditionalParams = {
            'filter.group.id': this.data.worker.group.id,
            'filter.role': Role.executor,
            status: PersonStatusEnum.active, // не влияет на фильтры. нужен для фильтрации в PersonSelectorService на фронте
            'filter.dateFrom': this.data.currentDate,
            'filter.id': `$not:${this.data.worker.id}`,
        };
    }

    close(): void {
        this.dialogRef.close();
    }

    submit(workerId: number): void {
        const queryParams = {
            'filter.executor.id': workerId,
            'filter.dateFrom': this.data.currentDate,
        };
        this.loading.set(true);
        this.ordersService.getAllOrders(queryParams).subscribe({
            next: value => {
                const currentWorkerTasks = value.map(task => {
                    return {
                        id: task.data.id,
                        executorId: this.data.worker.id
                    };
                });
                const newWorkerTasks = this.data.workerTasks.map(task => {
                    return {
                        id: task.data.id,
                        executorId: workerId
                    };
                });

                this.updateTasks([...currentWorkerTasks, ...newWorkerTasks]);
            },
            error: () => {
                this.messageService.errorMessage('Ошибка получения заявок');
                this.loading.set(false);
            }
        });
    }

    updateTasks(tasks: IOrderDataUpdate[]): void {
        this.ordersService.updateOrders(tasks).subscribe({
            next: value => {
                this.dialogRef.close(value);
            },
            error: () => this.messageService.errorMessage('Ошибка обновления заявок')
        }).add(() => this.loading.set(false));
    }

}

